import { forwardRef } from 'react'
import { Body, Box, CenteredBox } from '..'

export const ToggleButtons = forwardRef(function ToggleButtons({ labels, value, onChange, refButtonIndex }, ref) {
  return (
    <Box fullWidth gap={8}>
      {labels.map((label, index) =>
        <CenteredBox
          key={index}
          width="50%"
          height={54}
          r={16}
          ref={refButtonIndex === index ? ref : null}
          background={index === value ? 'var(--blue)' : '#1e1e1e'}
          border="1px solid white"
          shadow="2px 2px 0px 0px white"
          onClick={() => onChange?.(index)}
        >
          <Body alt weight={600} size={12} align="center" lineHeight={1.2}>
            {label}
          </Body>
        </CenteredBox>
      )}
    </Box>
  )
})